import { makeVar } from '@apollo/client';

export const entityContextVar = makeVar(null);
